// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wsio","label":"styles_label__16Eep"};